import { createStyles } from '@mantine/core';
import themeVariables from '@/styles/themeVariables';

export const createStatisticsCardStyles = createStyles((_, dark) => ({
  title: {
    fontSize: 18,
    fontWeight: 600,
    marginBottom: 12,
    color: dark?.dark
      ? themeVariables.label.normalDark
      : themeVariables.fontColors.extraDark,
  },
}));
